import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SerializedSelfServiceWebappResponse } from '@libs/selfService/config';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../@core/services/environment.service';
@Injectable({
  providedIn: 'root',
})
export class SelfServiceService {
  private readonly apiUrl: string = '';

  constructor(
    private readonly http: HttpClient,
    private readonly environmentService: EnvironmentService,
  ) {
    this.apiUrl = this.environmentService.selfserviceServiceUrl + '/webapp/selfservice';
  }

  /**
   * Get all selfservices
   */
  getAllSelfServices(): Observable<SerializedSelfServiceWebappResponse[]> {
    return this.http
      .get<SerializedSelfServiceWebappResponse[]>(this.apiUrl, {
        params: {
          sortBy: 'orderId',
          orderBy: 'asc'
        },
      });
  }

  getSelfServiceByType(type: string): Observable<SerializedSelfServiceWebappResponse> {
    return this.http.get<SerializedSelfServiceWebappResponse>(`${this.apiUrl}/${type}`);
  }

  validateToken(token: string): Promise<boolean> {
    return new Promise((resolve) => {
      fetch(this.apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': 'it',
          'Authorization': `Bearer ${token}`,
        }
      })
        .then(response => {
          if (response.ok) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch(() => {
          resolve(false);
        });
      // this.http.get<boolean>(this.apiAppUrl + '/validate-token', { params: { token } }).subscribe({
      //   next: (res) => {
      //     resolve(res);
      //   },
      //   error: (err) => {
      //     resolve(false);
      //   },
      // });

    });
  }
}